import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-banner-dialog',
  templateUrl: './warning-banner-dialog.component.html',
  styleUrls: ['./warning-banner-dialog.component.scss']
})
export class WarningBannerDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<WarningBannerDialogComponent>
  ) {
    this.dialogRef.disableClose = true;
   }

  ngOnInit() {
  }

  ok() {
    this.dialogRef.close();
    sessionStorage.setItem(btoa('showBanner'), btoa('false'));
  }

}
